/**
 *
 * @param {String} date  - format DD/MM/YYYY
 */

const FormatDateOfBirthForApiCall = (date = '') => {
	const regex = RegExp(/^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/]\d{4}$/i);

	if (!regex.test(date)) {
		throw new Error(`Invalid date format ${date}.`);
	}
	let dateArray = date.split('/');
	let day = dateArray[0],
		month = dateArray[1],
		year = dateArray[2];
	return {
		day,
		month,
		year,
		dob: `${year}-${month}-${day}`,
	};
};

export default FormatDateOfBirthForApiCall;
